// @flow
import React from "react";

import SectionHeader from "./commons/SectionHeader";
import Section from "./commons/Section";
import CoverPic from "./commons/CoverPic";

const STYLE_LI = {
  margin: "10px 0",
};

const Histoire = () => {
  return (
    <div style={{}}>
      <SectionHeader>Notre histoire</SectionHeader>
      <CoverPic src="vignes_automne.jpg" />
      <Section>
        <p style={{ textAlign: "justify", margin: 20 }}>
          <h4 style={{}}>Un vignoble en permaculture</h4>
          Depuis plusieurs années, nous favorisons la création d’écosystèmes
          dans nos vignes. En 2015, nous avons commencé en implantant du paturin
          avec du trèfle ou quelques fleurs pour enherber nos premières vignes
          complètement.
          <br />
          Nous nous sommes rendu compte au fil du temps que d’autres espèces
          apparaissaient. Au lieu de chercher à les détruire et favoriser celles
          que nous avions installées, nous avons choisi de laisser la nature
          prendre place et de simplement entretenir nos vignes au minimum pour
          pouvoir les travailler dans de bonnes conditions.
          <br />
          Aujourd’hui, ce sont des dizaines de plantes aussi variées que
          possible que nous trouvons au milieu de nos vignes. Cela va de l’ortie
          et du chardon, au trèfle, à la menthe, ou aux fraises des bois. Chaque
          plante a son utilité : certaines attirent des insectes pollinisateurs
          ou qui régulent d’autres populations à risque pour nos vignes,
          certaines vont décompacter le sol avec des racines profondes et vont
          favoriser l’infiltration des pluies dans le sol, d’autres, vont
          enrichir le sol ou favoriser l’apparition de mycorhyses, des
          champignons qui se développent autour des racines pour un meilleur
          développement de la plante.
          <br />
          Nos sols profitent d’une vie complète et exceptionnelle et c’est grâce
          à ces écosystèmes et cette biodiversité retrouvés que nos vins
          reflètent le meilleur de nos terroirs.
          <br />
          Notre exploitation a démarré sa conversion biologique en 2021
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            flexWrap: "wrap",
          }}
        >
          <div style={{ flex: 1, margin: 20, minWidth: 300 }}>
            <h4 style={{}}>Nos vins</h4>
            <p style={{ textAlign: "justify" }}>
              Un objectif, mettre en valeur ce que nos parcelles nous offrent
              chaque année. Les vins sont élevés sur lies, puis sur lies fines
              avant de les mettre en bouteilles afin de leur donner volume,
              gourmandise et complexité.
              <br />
              Nous ne filtrons pas nos vins pour qu’ils gardent toute leur
              matière et développent un potentiel de garde bien meilleur. Nos
              champagnes bénéficient d’un élevage en bouteille minimal de 2 à 3
              ans et d’un an de repos après dégorgement dans nos caves.
              <br />
              Depuis 2018, nous vinifions une partie de nos vins en fûts ou sans
              fermentation malo-lactique pour de nouvelles cuvées à venir !
              <br />
              <span style={{ fontWeight: "bold" }}>
                Cette année, notre nouveauté, un Coteau Champenois, le Clos des
                potiers.
              </span>
            </p>
          </div>
          <div style={{ flex: 1, margin: 20, minWidth: 300 }}>
            <a href="20191011_160719.jpg" target="_blank">
              <img
                src="20191011_160719.jpg"
                alt="Bruno verre à la main"
                width="100%"
              />
            </a>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            flexWrap: "wrap",
          }}
        >
          <div style={{ flex: 1, margin: 20, minWidth: 300 }}>
            <a href="20191011_160615.jpg" target="_blank">
              <img
                src="20191011_160615.jpg"
                alt="Bruno avec ses cuves"
                width="100%"
              />
            </a>
          </div>
          <div style={{ flex: 1, margin: 20, minWidth: 300 }}>
            <h4 style={{}}>Dans nos bouteilles</h4>
            <p style={{ textAlign: "justify" }}>
              <ul>
                <li style={STYLE_LI}>
                  Brut Vignoble : la structure du Chardonnay, la finesse, le
                  fruit du Meunier
                </li>
                <li>Blanc de Noirs : la Gourmandise, la rondeur du Meunier</li>
                <li style={STYLE_LI}>
                  Brut Vignoble rosé : les Fruits rouges et la structure du
                  Meunier
                </li>
                <li style={STYLE_LI}>
                  Millésime 2013 : l’élégance de notre premier Blanc de blancs
                  (médaille d’or)
                </li>
                <li style={STYLE_LI}>
                  Coteau Champenois « Le clos des potiers » : une autre
                  expression de notre terroir !
                </li>
              </ul>
            </p>
          </div>
        </div>
      </Section>
    </div>
  );
};

export default Histoire;



// WEBPACK FOOTER //
// ./src/Histoire.js